module.exports = __webpack_public_path__ + "img/wizard-header-Referra-1102x529.7600e6ac.png";